import * as yup from 'yup';

import { regex, formUtils } from '../../../../shared/utils';

const { field, sectionTitle } = formUtils;

const DIFFERENT_CONTACT = 'differentContact_';

const contactSchema = (t, values, forceName = '', show) =>
  show
    ? [
        [
          {
            span: 24,
            columns: [
              field('input', `${forceName}name`, t, values, {
                required: true,
                tabIndex: forceName ? 6 : 3
              })
            ]
          }
        ],
        [
          {
            span: 12,
            columns: [
              field('input', `${forceName}phone`, t, values, {
                required: true,
                tabIndex: forceName ? 7 : 4,
                placeholder: t('phone.placeholder'),
                showCountrySelector: true,
                defaultValue: "+1",
                prefix: '+1',
                mask: 'phone'
              })
            ]
          },
          {
            span: 12,
            columns: [
              field('input', `${forceName}email`, t, values, {
                required: true,
                type: 'email',
                tabIndex: forceName ? 8 : 5
              })
            ]
          }
        ]
      ]
    : [];

const formSchema = (t, values, initializing) => {
  const contactSameAsPrimary = !!(values && values['contactSameAsPrimary']);
  return [
    sectionTitle('organizationsSectionTitle', t, 24, { marginTop: 0 }),
    [
      {
        span: 24,
        columns: [
          field('input', 'organization', t, values, {
            required: true,
            tabIndex: 1
          })
        ]
      }
    ],
    [
      {
        span: 24,
        columns: [
          field('input', 'clientOrganization', t, values, {
            tabIndex: 2
          }, true)
        ]
      }
    ],
    sectionTitle('primaryContactSectionTitle', t),
    ...contactSchema(t, values, '', true),
    sectionTitle(
      'technicalContactSectionTitle',
      t,
      24,
      {},
      { sublabel: t('technicalContactSublabel') }
    ),
    [
      {
        span: 24,
        columns: [
          field('checkbox', 'contactSameAsPrimary', t, values, {
            checked: values && values['contactSameAsPrimary'] ? true : false,
            tabIndex: contactSameAsPrimary ? 6 : 9,
            paddingTop: '0px'
          })
        ]
      }
    ],
    ...contactSchema(
      t,
      values,
      DIFFERENT_CONTACT,
      values && !values['contactSameAsPrimary'] ? true : false
    )
  ];
};

const validationSchema = (t, values, initializing) => {
  const differentContact =
    values && !values['contactSameAsPrimary']
      ? {
          [`${DIFFERENT_CONTACT}name`]: yup
            .string()
            .required(t(`name.error_required`)),
          [`${DIFFERENT_CONTACT}email`]: yup
            .string()
            .email(t(`email.error_invalid`))
            .required(t(`email.error_required`)),
          [`${DIFFERENT_CONTACT}phone`]: yup
            .string(t(`phone.error_invalid`))
            .matches(regex.phoneCountryCode, t(`phone.error_required`))
            .matches(regex.phoneMinimumLength, t(`phone.error_invalid`))
            .required(t(`phone.error_required`))
        }
      : {};

  return yup.object().shape({
    ...differentContact,
    organization: yup.string().required(t('organization.error_required')),
    clientOrganization: yup.string(),
    contactSameAsPrimary: yup.string(),
    name: yup.string().required(t('name.error_required')),
    email: yup
      .string()
      .email(t('email.error_invalid'))
      .required(t('email.error_required')),
    phone: yup
      .string()
      .matches(regex.phoneCountryCode, t(`phone.error_required`))
      .matches(regex.phone, t(`phone.error_invalid`))
      .required(t('phone.error_required'))
  });
};

export { formSchema, validationSchema };
